function isMobileDevice() {
    return window.innerWidth <= 1100 || window.navigator.userAgent.includes("Mobi");
}

function isProductPage() {
    // Assuming your product page URL contains '/product/', you can adjust based on your setup
    return window.location.pathname.includes("/products/");
}

function updateStickyButtonVisibility() {
    var threshold = 0.5 * window.innerHeight;

    // Check conditions for stickyCartButton
    if (isMobileDevice() || (isProductPage() && !isMobileDevice())) {
        if (window.scrollY > threshold) {
            stickyCartButton.style.opacity = "1";
            stickyCartButton.style.visibility = "visible";
        } else {
            stickyCartButton.style.opacity = "0";
            stickyCartButton.style.visibility = "hidden";
        }
    } else {
        // If not on product page in desktop, always hide the button
        stickyCartButton.style.opacity = "0";
        stickyCartButton.style.visibility = "hidden";
    }

    // Check condition for lastNavItem to hide it on the product page
    if (isProductPage()) {
        lastNavItem.style.display = "none"; // Hide the button
    } else {
        lastNavItem.style.display = "block"; // Show the button
    }
}

// Call the function on load to set initial state
var stickyCartButton, lastNavItem;
document.addEventListener('DOMContentLoaded', function() {

  stickyCartButton = document.querySelector(".sticky-add-cart");
  lastNavItem = document.querySelector(".header-nav li:last-child a"); // Select the specified button

  updateStickyButtonVisibility();

  // And then on scroll
  window.addEventListener("scroll", updateStickyButtonVisibility);
});

